import React, { useRef } from "react";
import * as styles from "./withSkipMap.module.scss";

export const withSkipMap =
	<P extends object>(MapComponent: React.FC<P>): React.FC<P> =>
	(props) => {
		const skipMapButtonRef = useRef<HTMLButtonElement>(null);
		const mapSkippedButtonRef = useRef<HTMLButtonElement>(null);

		return (
			<>
				<button
					ref={skipMapButtonRef}
					className={styles.hiddenButton}
					type="button"
					aria-label="Click to skip map to view data in list format"
					onClick={() => mapSkippedButtonRef.current?.focus()}
					aria-live="polite"
					tabIndex={0}
				/>
				<MapComponent {...(props as P)} />
				<button
					ref={mapSkippedButtonRef}
					className={styles.hiddenButton}
					type="button"
					aria-label="Click to skip above map"
					onClick={() => skipMapButtonRef.current?.focus()}
					tabIndex={0}
				/>
			</>
		);
	};
